import React, { useEffect, useState } from "react";
import { RedirectKeepUTM } from "../../../shared/components/RedirectKeepUTM";
import { useDispatch } from "react-redux";
import CircularProgress from "@material-ui/core/CircularProgress";

import { validateUpdatePrimaryEmailParticipantService } from "../../services";
import { useSearchParams } from "../../../shared/hooks/useSearchParams";
import { logout } from "../../actions/logout.actions";
import { LoginLocationState } from "../loginPage/loginPage";

export const ParticipantUpdateEmailPage = () => {
  const query = useSearchParams();
  const [isFething, setIsFetching] = useState(true);
  const [isIdValid, setIsIdValid] = useState(true);
  const dispatch = useDispatch();

  const queryId = query.get("id");
  useEffect(() => {
    (async () => {
      try {
        const response = await validateUpdatePrimaryEmailParticipantService({
          id: queryId,
        });
        if (response.status !== 200) {
          setIsIdValid(false);
          return;
        }
        dispatch(logout());
      } catch (e) {
        setIsIdValid(false);
      } finally {
        setIsFetching(false);
      }
    })();
  }, [dispatch, queryId]);

  if (isFething) {
    return <CircularProgress color="secondary" />;
  }

  return (
    <RedirectKeepUTM
      to={{
        pathname: "/",
        state: {
          isTokenUpdateEmailExpired: !isIdValid,
          isSuccesUpdatePrimaryEmail: isIdValid,
        } as LoginLocationState,
      }}
    />
  );
};
